import { useCallback, useState } from "react"

interface localStorageTtlData {
    value: string
    expiredAt: number
}

export const localStorageTtl = {
    setItem: (key: string, value: string, ttlMs: number) => {
        const data: localStorageTtlData = {
            value,
            expiredAt: new Date().getTime() + ttlMs
        }
        localStorage.setItem(key, JSON.stringify(data))
    },
    getItem: (key: string) => {
        const json = localStorage.getItem(key)
        if (json === null) {
            return null
        }

        const data: localStorageTtlData = JSON.parse(json)
        if (data.expiredAt && data.expiredAt < new Date().getTime()) {
            localStorage.removeItem(key)
            return null
        }
        return data.value
    }
}

export const useLocalStorageTtl = (key: string, ttlMs: number) => {
    const [value, _setValue] = useState(
        localStorageTtl.getItem(key) ?? undefined
    )

    const setValue = useCallback(
        (_value: string) => {
            localStorageTtl.setItem(key, _value, ttlMs)
            _setValue(_value)
        },
        [key, ttlMs]
    )

    return { value, setValue }
}
